import { colHeaders } from "../../Constants/colHeaders";

export default function resetSelectAllCheckbox() {

    let checkboxOption = "";
    checkboxOption = "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50'";
    checkboxOption += ">";
    colHeaders[0] = checkboxOption;
}